import { motion } from "framer-motion";
import Chapter from "./Chapter";

export default function BreadthEdge() {
  return (
    <section className="relative py-14 md:py-20 hairline-t">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Chapter number="06" label="India & AI · first-class" />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <EdgeCard
            badge="DPDP-NATIVE"
            title="Built for India's DPDP Act."
            body="Data Principal rights, Consent Manager handoff, cross-border transfer rules, breach notice timelines — mapped and modelled, not bolted on."
            codes={["§4 · Notice", "§5 · Consent", "§8 · Reasonable security", "§17 · Cross-border"]}
          />
          <EdgeCard
            badge="ISO 42001"
            title="AI governance as a framework, not a checkbox."
            body="Model registry, risk assessment, human oversight, algorithmic impact — controls scoped for teams shipping AI, not just talking about it."
            codes={["6.2.1 · AI objectives", "6.1 · Risks & opps", "8.3 · Impact assessment", "10.1 · Improvement"]}
          />
        </div>
      </div>
    </section>
  );
}

function EdgeCard({ badge, title, body, codes }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: [0.22,1,0.36,1] }}
      className="machined p-8 md:p-10 relative overflow-hidden"
    >
      <div className="flex items-center justify-between">
        <span className="inline-flex items-center gap-2 px-2.5 py-1 rounded-sm border border-white/15 font-mono text-[9.5px] tracking-[0.24em] uppercase text-white/70">
          {badge}
        </span>
        <span className="font-mono text-[9.5px] tracking-[0.24em] uppercase text-ink-muted">Differentiator</span>
      </div>
      <h3 className="mt-8 font-display text-[26px] md:text-[32px] leading-tight tracking-[-0.02em] text-balance">
        {title}
      </h3>
      <p className="mt-4 text-ink-muted text-[15px] leading-relaxed max-w-[52ch]">{body}</p>
      <div className="mt-6 flex flex-wrap gap-2">
        {codes.map((c) => (
          <span key={c} className="font-mono text-[10px] px-2.5 py-1 rounded-sm border border-white/8 bg-white/[0.02] text-white/60">
            {c}
          </span>
        ))}
      </div>
    </motion.div>
  );
}
